export const SEARCH_OPTIONS = {
  DEFAULT: 'Places/Account',
  HEATMAP: 'Heatmaps',
  PEOPLE: 'People',
  SERVICE: 'Service',
  ZONE: 'Zone',
  EXECUTIVE: 'Executive'
};
